
import { defineComponent, ref, computed, PropType, SetupContext } from 'vue';

interface ITabOption {
  value: string;
  label: string;
  itemClasses?: unknown[];
  txtClasses?: unknown[];
}

export default defineComponent({
  name: 'Tab',
  components: {},
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    options: {
      type: Array as unknown as PropType<ITabOption[]>,
      default: () => [],
    },
    theme: {
      type: String as PropType<'blue' | 'gray'>,
      default: 'blue',
    },
  },
  emits: ['click', 'update:modelValue'],
  setup(props, context: SetupContext) {
    const prefixCls = ref('tab');
    const getClasses = computed(() => ({
      wrap: [`${prefixCls.value}`],
      body: [`${prefixCls.value}-list`],
    }));

    const getFormatOptions = computed(() => {
      const temp = props.options.concat();
      temp.forEach((item) => {
        if (item.value === props.modelValue) {
          // eslint-disable-next-line no-param-reassign
          item.itemClasses = [
            `${prefixCls.value}-panel`,
            props.theme === 'gray' && `${prefixCls.value}-panel_gray`,
            `${prefixCls.value}-panel_active`,
          ];
          // eslint-disable-next-line no-param-reassign
          item.txtClasses = [`${prefixCls.value}-txt`, props.theme === 'gray' && `${prefixCls.value}-txt_gray`];
        } else {
          // eslint-disable-next-line no-param-reassign
          item.itemClasses = [`${prefixCls.value}-panel`, props.theme === 'gray' && `${prefixCls.value}-panel_gray`];
          // eslint-disable-next-line no-param-reassign
          item.txtClasses = [`${prefixCls.value}-txt`, props.theme === 'gray' && `${prefixCls.value}-txt_gray`];
        }
      });
      return temp;
    });
    /** 对外响应的事件 */
    const listener = (event: Event) => context.emit('click', event);
    const onTapByItem = (value: string) => {
      if (props.modelValue === value) {
        return;
      }
      context.emit('update:modelValue', value);
      // context.emit('change', value);
    };

    return { getClasses, getFormatOptions, listener, onTapByItem };
  },
});
